// WeddingCountdown.jsx
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import iglesia from '../../../assets/iglesia.png';
import jardines from '../../../assets/jardines.png';
import { Button } from '../../../components';

const CeremonySection = styled.div`
  margin-top: 4rem;

  display: flex;
  flex-direction: column;
  align-items: center;

  font-family: var(--text-cursive);

  h3 {
    font-family: var(--text-title);
    font-size: 1.5rem;
    font-weight: 800;

    margin: 0.75rem 0 0.75rem;
  }

  p {
    font-size: 1.6rem;
    margin: 0;
    display: flex;
    width: fit-content;
  }

  .antic {
    font-size: 1.2rem;
  }

  img {
    max-width: 175px;
    height: auto;
    margin: 0;
  }
`;

const Places = () => {
  return (
    <>
      <CeremonySection>
        <img src={iglesia} alt="Parroquia Santiago Apóstol" />
        <h3>Ceremonia</h3>
        <p>12:00 - Parroquia Santiago Apóstol</p>
        <p className="antic">(Villanueva de Alcardete)</p>
        <Button as="a" href="https://maps.app.goo.gl/uttKmHY7TCp42YZM9" target="_blank">
          Ver ubicación
        </Button>
      </CeremonySection>

      <CeremonySection>
        <img src={jardines} alt="Jardines de Palacio" />
        <h3>Celebración</h3>
        <p>14:00 - Jardines de Palacio</p>
        <p className="antic">(Villacañas)</p>
        <Button as="a" href="https://maps.app.goo.gl/r7uV5wkDFy8eSvcA9" target="_blank">
          Ver ubicación
        </Button>
      </CeremonySection>
    </>
  );
};

export default Places;
